module.exports = __webpack_public_path__ + "media/images/badges/purebarre/PureBarre-4500-Classes-Inactive-6d8c706d5b34cb68bcb0c2722c15191b.png";